/**
 * Utilities and shortcuts.
 *
 * Uninest/Karmabooking
 *
 * Copyright (c) 2020 Karmabunny
 */

import { DateTime, FixedOffsetZone } from "luxon";

/**
 * Get the date part of a date as an ISO format string.
 * e.g. '2020-03-04'
 *
 * TODO this is actually a terrible name.
 */
export function getISODate(date?: Date | null) {
    if (!date || !(date instanceof Date)) return null;
    return date.toISOString().replace(/T.+$/, '');
}

type NameStyle = "long" | "short" | "narrow";

/**
 * Yes, DateTimeFormat is supported on IE11. (but not Safari 9).
 *
 * Pinched from: https://stackoverflow.com/a/47232630/7694753
 */
export function getMonthNames(locale: string, style: NameStyle) {
    const formatter = new Intl.DateTimeFormat(locale, { month: style, timeZone: 'UTC' });
    const zone = FixedOffsetZone.utcInstance;

    const names: String[] = [];

    for (let i = 1; i <= 12; i++) {
        const date = DateTime.fromObject({ year: 2000, month: i, day: 1 }, { zone });
        names.push(formatter.format(date.toJSDate()));
    }

    return names;
}


/**
 * Yes, DateTimeFormat is supported on IE11. (but not Safari 9).
 */
export function getWeekNames(locale: string, style: NameStyle, offset = 0) {
    const formatter = new Intl.DateTimeFormat(locale, { weekday: style, timeZone: 'UTC' });
    const zone = FixedOffsetZone.utcInstance;

    const names: String[] = [];

    for (let i = 1; i <= 7; i++) {
        // October 2000 starts on a Sunday.
        const date = DateTime.fromObject({ year: 2000, month: 10, day: i + offset }, { zone });
        names.push(formatter.format(date.toJSDate()));
    }

    return names;
}


export function propertyMapIcon(property_id: string) {
    try {
        return require(`@/assets/images/properties/mm_${property_id}.png`);
    }
    catch (error: any) {
        return require(`@/assets/images/properties/img_fallback.png`);
    }
}


export function propertyIcon(property_id: string) {
    try {
        return require(`@/assets/images/properties/img_${property_id}.svg`);
    }
    catch (error: any) {
        return require(`@/assets/images/properties/img_fallback.svg`);
    }
}


export function propertyImage(property_id: string) {
    try {
        return require(`@/assets/images/properties/img_location_${property_id}.jpg`);
    }
    catch (error: any) {
        return require(`@/assets/images/properties/img_location_fallback.png`);
    }
}


export function mapState(mutator: string, keys: string[]) {
    const computed = {} as any;

    for (let key of keys) {
        computed[key] = {
            get(this: Vue) {
                return this.$store.state[key];
            },
            set(this: Vue, value: any) {
                this.$store.commit(mutator, { [key]: value });
            }
        }
    }
    return computed;
}

export function mapGetState(keys: string[]) {
    const computed = {} as any;

    for (let key of keys) {
        computed[key] = function(this: Vue) {
            return this.$store.state[key];
        }
    }

    return computed;
}

export function mapGetters(keys: string[]) {
    const computed = {} as any;

    for (let key of keys) {
        computed[key] = function(this: Vue) {
            return this.$store.getters[key];
        }
    }

    return computed;
}
